import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { IoEye, IoEyeOff } from "react-icons/io5";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  FaLock,
  FaUserAlt,
  FaUserEdit,
  FaUserLock,
  FaUserPlus,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { checkMailServerExists, login, whoAmI } from "../../server/server";
import { useUser } from "../../auth/UseUser";
import { ReactComponent as Grb } from "../../assets/svg/srbija-grb.svg";
import { IconButton } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
const theme = createTheme({
  typography: { fontFamily: "Fira Sans Condensed" },
});

export default function SignIn() {
  const { setUser } = useUser();
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [datas, setDatas] = useState<any>(null);
  const [screen, setScreen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mailServerExists, setMailServerExists] = useState(false);

  const [fieldErrors, setFieldErrors] = useState<{
    username?: string;
    password?: string;
  }>({});
  const [fieldTouched, setFieldTouched] = useState<{
    username?: boolean;
    password?: boolean;
  }>({});

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const username = data.get("username") as string;
    const password = data.get("password") as string;
    const errors: { username?: string; password?: string } = {};
    if (!username) errors.username = "Обавезно поље";
    if (!password) errors.password = "Обавезно поље";
    setFieldTouched({ username: true, password: true });
    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      setErrorMessage("");
      return;
    }

    const resp = await login({
      username,
      password,
    });
    if (resp?.status === 201) {
      const data = resp.data;
      await localStorage.setItem("accessToken", data["accessToken"]);

      const response = await whoAmI();
      if (response.status === 200) {
        setScreen(true);
        setDatas(response?.data);
      } else {
      }
    } else {
      setErrorMessage(resp?.data?.message);
    }
  };
  const handleRolePick = async (role: any) => {
    setUser({ ...datas, roleView: role });
    await localStorage.setItem(
      "user",
      JSON.stringify({ ...datas, roleView: role }),
    );
  };
  const ROLE_ICON_MAP = {
    Администратор: <FaUserTie className=" " />,
    Координатор: <FaUserAlt className="" />,
    "Уносилац података": <FaUserEdit className="w-5 h-5" />,
    "Секретар преговарачке групе": <FaUsers className="w-5 h-5" />,
    "Одговорна особа": <FaUserLock className="w-5 h-5" />,
  };

  useEffect(() => {
    if (screen && datas?.roles?.length === 1) {
      handleRolePick(datas?.roles[0]);
    }
  }, [screen]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/docs/smernice.pdf";
    link.download = "Смернице и консултације са ЕК, 2023.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const logoutUser = async () => {
    setScreen(false);
    setDatas(null);
    await localStorage.removeItem("accessToken");
    await localStorage.removeItem("user");
  };

  const checkIfMailServerExists = async () => {
    const resp = await checkMailServerExists();

    if (resp?.status === 200) {
      setMailServerExists(resp.data.exists);
    }
  };

  useEffect(() => {
    checkIfMailServerExists();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <div className="flex flex-col justify-between gap-2 items-center">
            <Grb />
            <div className="flex flex-col mt-2 items-center">
              <span className="font-medium text-xl">Република Србија</span>
              <span className="text-xl">
                Министарство за европске интеграције
              </span>
            </div>
          </div>
          {screen && datas?.roles?.length != 1 ? (
            <div className="flex flex-col items-center">
              <h1 className="text-2xl mt-6 text-darkBlue text-center">
                Одабир надлежности
              </h1>
              <div className="flex flex-wrap w-[490px] justify-between gap-y-2 mt-4 ">
                {datas?.roles?.map((r: any) => {
                  return (
                    <div
                      className="w-[240px] h-[100px] border gap-3 text-[#0f2765d2] border-darkBlue rounded-lg flex flex-col items-center justify-center hover:bg-darkBlue hover:text-white cursor-pointer"
                      onClick={() => handleRolePick(r)}
                      key={r?.name}
                    >
                      {ROLE_ICON_MAP[r?.name as keyof typeof ROLE_ICON_MAP]}
                      {r?.name}
                    </div>
                  );
                })}
              </div>
              <div
                className="mt-10 bg-darkBlue text-white p-4 rounded-lg cursor-pointer"
                onClick={() => logoutUser()}
              >
                Одјави се
              </div>
            </div>
          ) : (
            <div>
              <p className=" text-darkBlue text-center  mt-6">
                Национални програм за усвајање правних тековина ЕУ
              </p>
              <h1 className="text-2xl text-darkBlue text-center">
                Приступ апликацији
              </h1>

              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Корисничко име"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  error={Boolean(fieldErrors.username)}
                  helperText={fieldErrors.username}
                  onBlur={() =>
                    setFieldTouched((prev) => ({ ...prev, username: true }))
                  }
                  FormHelperTextProps={{ style: { color: "red" } }}
                  InputProps={{
                    style: fieldErrors.username
                      ? { borderColor: "red" }
                      : undefined,
                  }}
                  inputProps={{
                    style: fieldErrors.username ? { color: "red" } : undefined,
                    placeholder: fieldErrors.username
                      ? "Koрисничко име"
                      : undefined,
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Лозинка"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  error={Boolean(fieldErrors.password)}
                  helperText={fieldErrors.password}
                  onBlur={() =>
                    setFieldTouched((prev) => ({ ...prev, password: true }))
                  }
                  FormHelperTextProps={{ style: { color: "red" } }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={{
                          backgroundColor: "transparent",
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      >
                        {showPassword ? <IoEyeOff /> : <IoEye />}
                      </IconButton>
                    ),
                    style: fieldErrors.password
                      ? { borderColor: "red" }
                      : undefined,
                  }}
                  inputProps={{
                    style: fieldErrors.password ? { color: "red" } : undefined,
                    placeholder: fieldErrors.password
                      ? "Обавезно поље"
                      : undefined,
                  }}
                />
                <Typography component="p" sx={{ color: "error.main" }}>
                  {errorMessage}
                </Typography>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, backgroundColor: "#0F2765" }}
                >
                  Пријави се
                </Button>
                {mailServerExists && (
                  <div
                    className="text-center mt-1 text-[18px] cursor-pointer text-darkBlue underline"
                    onClick={() => navigate("/password-reset")}
                  >
                    Заборављена лозинка?
                  </div>
                )}
              </Box>
            </div>
          )}

          {!screen && (
            <div
              className="text-center mt-4 text-[18px] cursor-pointer text-darkBlue underline"
              onClick={handleDownload}
            >
              Смернице и консултације са ЕК, 2023
            </div>
          )}
        </Box>
      </Container>
    </ThemeProvider>
  );
}
